module.exports = __webpack_public_path__ + "img/trash.41cc8b8d.svg";